import React from 'react';
import { Logout } from '@mui/icons-material';
import { Box, Button, styled } from '@mui/material';
//
import { removeToken } from '@utils';

const MuiLogout = styled(Button)(({ theme }) => ({
  fontSize: '0.875rem',
  color: theme.palette.grey[600],
  backgroundColor: theme.palette.background.paper,
  // boxShadow: '0px 5px 10px 5px rgba(0, 0, 0, 0.1)',
  borderRadius: 4,

  '&:hover': {
    color: theme.palette.grey[800],
    backgroundColor: theme.palette.background.paper,
  },

  '& .MuiSvgIcon-root': {
    fontSize: '1.1rem',
  },
}));

const LogoutCmp: React.FC = () => {
  const handleLogout = () => {
    removeToken();

    window.location.href = '/';
  };
  return (
    <MuiLogout variant="text" startIcon={<Logout />} onClick={handleLogout}>
      Sign out
    </MuiLogout>
  );
};

export default LogoutCmp;
